import PlusIcon from '../../../assets/icons/plus.svg?react';
import EditIcon from '../../../assets/icons/edit.svg?react';
import DeleteIcon from '../../../assets/icons/delete.svg?react';
import TargetIcon from '../../../assets/icons/target.svg?react';

import { useNotificationRuleList } from '../../../hooks/queries/logQueries';
import { SkeletonTable } from '../../../components/Skeleton';
import dayjs from 'dayjs';
import Pagination from '../../../components/Pagination/Pagination';
import { useSearchParams } from 'react-router-dom';
import { useState } from 'react';
import AlertSetUpTargetEditModal from './AlertSetUpTargetEditModal';
import AlertSetUpAppendSideModal from './AlertSetUpAppendSideModal';
import AlertSetUpEditSideModal from './AlertSetUpEditSideModal';
import AlertSetUpDeleteModal from './AlertSetUpDeleteModal';
import AlertSetUpTargetListModal from './AlertSetUpTargetListModal';

const AlertSetUp = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [isAppendModalOpen, setIsAppendModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [updateModalOpen, setUpdateModalOpen] = useState(false);
  const [isTargetListModalOpen, setIsTargetListModalOpen] = useState(false);
  const [target, setTarget] = useState(null);
  
  const currentPage = parseInt(searchParams.get('page')) || 1;
  const pageSize = parseInt(searchParams.get('pageSize')) || 10;
  const sortBy = searchParams.get('sortBy') || 'CreatedDate';
  const sortOrder = searchParams.get('sortOrder') || 'desc';

  const { data: notificationRuleList, isLoading: isLoadingNotificationRuleList, refetch: refetchNotificationRuleList } = useNotificationRuleList({
    page: currentPage,
    pageSize: pageSize,
    orderBy: sortBy,
    orderDirection: sortOrder,
  });

  const totalPages = notificationRuleList?.Total ? Math.ceil(notificationRuleList.Total / pageSize) : 1;

  const handlePageChange = (page) => {
    setSearchParams({ ...searchParams, page: page.toString() });
  };
  const handleSort = (field, order) => {
    setSearchParams({ ...searchParams, sortBy: field, sortOrder: order, page: '1' });
  };
  const formatDateTime = (dateTimeString) => {
    if (!dateTimeString) return '-';
    return dayjs(dateTimeString).format('YYYY-MM-DD HH:mm:ss');
  };
  const handleDelete = (item) => {
    setTarget(item);
    setDeleteModalOpen(true);
  };
  const handleEdit = (item) => {
    setTarget(item);
    setUpdateModalOpen(true);
  };
  const handleEditSideModalOpen = (target) => {
    setTarget(target);
    setIsEditModalOpen(true);
  };
  const handleSuccess = async () => {
    await refetchNotificationRuleList();
    setIsAppendModalOpen(false);
    setIsEditModalOpen(false);
    setDeleteModalOpen(false);
    setUpdateModalOpen(false);
  };
  return (
    <div className="alert-setup-container">
      <div className="flex flex-col gap-10">
        <div className="flex align-center justify-end">
          <button className="btn big-btn btn-primary flex align-center gap-2" onClick={() => setIsAppendModalOpen(true)}>
            <PlusIcon />
            알림 규칙 추가
          </button>
        </div>
        <div className="primary-table">
          <table>
            <thead>
              <tr>
                <th>규칙명</th>
                <th>조건 타입</th>
                <th>조건 연산자</th>
                <th>조건 값</th>
                <th>활성 여부</th>
                <th width="200px">알림 대상</th>
                <th width="80px"></th>
              </tr>
            </thead>
            <tbody>
              {isLoadingNotificationRuleList ? (
                <SkeletonTable rows={pageSize} columns={6} />
              ) : (
                notificationRuleList?.Items?.map((item) => (
                  <tr key={item.NotificationRuleSysId}>
                    <td>{item.RuleName}</td>
                    <td>{item.ConditionType}</td>
                    <td>{item.ConditionOperator}</td>
                    <td>{item.ConditionValue}</td>
                    <td><span className={`status-badge ${item.IsActive ? 'info' : 'unknown'}`}>{item.IsActive ? '활성' : '비활성'}</span></td>
                    <td>
                      <div className='flex align-center justify-between'>
                        <div className='flex align-center gap-2'>
                          <TargetIcon color='var(--gray-600)' width={20} height={20} />  
                          <p className='text-b2-400 text-gray-600'>{item.NotificationTargets.length}</p>
                        </div>
                        <button className='btn small-btn btn-style-5' onClick={()=>{setIsTargetListModalOpen(true); setTarget(item)}}>대상 목록</button>
                      </div>
                    </td>
                    <td>
                      <div className='flex align-center gap-2'>
                        <button className='btn icon-btn' onClick={() => handleEditSideModalOpen(item)}>
                          <EditIcon color='var(--gray-600)'/>
                        </button>
                        <button className='btn icon-btn' onClick={() => handleDelete(item)}>
                          <DeleteIcon color='var(--gray-600)'/>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <div className="pagination-wrapper">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            size="medium"
          />
        </div>
      </div>
      {updateModalOpen && (
        <AlertSetUpTargetEditModal onClose={() => setUpdateModalOpen(false)} target={target} onSuccess={handleSuccess} />
      )}
      {isAppendModalOpen && (
        <AlertSetUpAppendSideModal onClose={() => setIsAppendModalOpen(false)} onSuccess={handleSuccess} />
      )}
      {isEditModalOpen && (
        <AlertSetUpEditSideModal onClose={() => setIsEditModalOpen(false)} target={target} onSuccess={handleSuccess} handleSuccess={handleSuccess} />
      )}
      {deleteModalOpen && (
        <AlertSetUpDeleteModal onClose={() => setDeleteModalOpen(false)} target={target} onSuccess={handleSuccess} />
      )}
      {isTargetListModalOpen && (
        <AlertSetUpTargetListModal onClose={() => setIsTargetListModalOpen(false)} target={target} onGoToEdit={(target) => handleEditSideModalOpen(target)} />
      )}
    </div>
  )
}

export default AlertSetUp